import React, { FC } from 'react';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import { OrderItemElement } from '../../../components';
import { useTranslation } from '../../../translations';
import { countBy, Fetcher, noop, useConvention, useFetcher } from '../../../utils';

interface TabDetailsProps {
  readonly userId: number;
  readonly refreshContents: (force?: boolean) => void;
}

export const UserOrdersTab: FC<TabDetailsProps> = ({ userId, refreshContents }) => {
  const { ts } = useTranslation();
  const convention = useConvention();

  const request = useFetcher(async () => {
    return await api.getOrdersForUser(userId);
  }, [userId]);

  async function createNew(): Promise<void> {
    await api.getActiveOrder(userId, true);
    refreshContents(true);
  }

  const categories = useFetcher(async () => await api.getProductCategories());

  if (!request.success) {
    return <Fetcher result={request} />;
  }

  const orders = request.data;

  if (!categories.data) {
    return <Fetcher result={categories} />;
  }

  return (
    <Row className="justify-content-center">
      {countBy(orders, (t) => t.status === 'unpaid' && t.conventionId === convention.id) === 0 && (
        <Col className="mb-10" lg={8} xs={12}>
          <Button color="primary" id="createOrder" onClick={createNew}>
            {ts('orders_tab.create_new_order')}
          </Button>
        </Col>
      )}
      {orders.length === 0 && (
        <Col id="noOrders" xs={12}>
          <Card>
            <CardBody className="text-secondary text-center">
              {ts('orders_tab.no_order_for_user')}
            </CardBody>
          </Card>
        </Col>
      )}
      <Col className="resultTable" id="ordersTable" lg={8} xs={12}>
        {orders
          .filter((t) => t.status === 'paid' || t.conventionId === convention.id)
          .map((order) => (
            <OrderItemElement
              categories={categories.data}
              id={`order_${order.id}`}
              key={order.id}
              onSelect={noop}
              order={order}
            />
          ))}
      </Col>
    </Row>
  );
};
